import styled from "@emotion/styled";
import { AppBar, Box, Button } from "@mui/material";
import { DRAWER_WIDTH } from "src/assets/data/initialData";
import { alpha } from "@mui/material/styles";

export const HeaderWaveLineBox = styled(Box)`
  position: absolute;
  top: 0;
  left: 5%;
  width: 100%;
  z-index: -1;
  margin: 0 auto;
`;

export const AppBarBox = styled(AppBar)`
  width: calc(100% - ${DRAWER_WIDTH + 38}px);
  margin-inline-start: ${DRAWER_WIDTH + 26}px;
  position: fixed;
  margin-top: ${({ theme }) => theme.spacing(1.5)};
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};
  margin-inline-end: ${({ theme }) => theme.spacing(1.5, 0)};
  border-radius: ${({ theme }) => theme.shape.borderRadius * 4}px;
  background-color: ${({ theme }) => theme.palette.grey.gb};
  > .MuiToolbar-root {
    min-height: 56px;
    width: 100%;
  }
`;
export const BadgeButton = styled(Button)`
  border-radius: ${({ theme }) => theme.shape.borderRadius * 2.5}px;
  padding: ${({ theme }) => theme.spacing(1)};
  margin: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ theme }) => theme.palette.text.primary};
  border-color: ${({ theme }) => theme.palette.text.caption};
  /* :hover {
    color: ${({ theme }) => theme.palette.text.caption};
  }
  :focus {
    color: ${({ theme }) => theme.palette.primary.contrastText};
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
  :active {
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.common.white};
    border-color: ${({ theme }) => theme.palette.primary.main};
  } */
`;

export const BtnDropDown = styled(Button)`
  padding: ${({ theme }) => theme.spacing(1)};
  background-color: ${({ theme }) => alpha(theme.palette.primary.main, 0.12)};
  position: relative;
  :focus {
    box-shadow: none !important;
    background-color: ${({ theme }) => theme.palette.primary.main} !important;
  }
  :hover {
    > span {
      color: ${({ theme }) => theme.palette.primary.contrastText} !important;
    }
    g,
    path {
      stroke: ${({ theme }) => theme.palette.primary.contrastText};
    }
  }
`;
